<template>
    <div class="video-wrapper">
        <el-upload style="width: 100%;height: 400px" drag action="" :before-upload="beforeUpload"
            :show-file-list="false">
            <div v-if="!val">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">点击或拖拽上传视频</div>
            </div>
            <video v-else style="height: 100%;" :src="val" alt=""></video>
        </el-upload>
    </div>
</template>

<script>
import { upload } from "@/api/upload";
export default {
    props: {
        value: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            val: "",
        };
    },
    watch: {
        value(val) {
            this.val = val;
        },
    },
    methods: {
        beforeUpload(file) {
            const [type] = file.type.split("/");
            if (type != "video") {
                this.$message.warning("请上传视频文件");
                return;
            }
            upload(file).then(({ code, message, result }) => {
                if (code == 200) {
                    this.val = result;
                    this.$emit("input", this.val);
                } else {
                    this.$message.error(message);
                }
            });
            return false;
        },
    },
};
</script>

<style lang="less" scoped>
.video-wrapper {

    :deep(.el-upload-dragger),
    :deep(.el-upload) {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>